module.exports = __webpack_public_path__ + "img/clubsaway-logo-mobile-d.38d22db9.svg";